import React from 'react';
import { Box, Paper } from '@mui/material';
import {
    PAGE_BAND_COLOR,
    contentPaperSx,
    embedContentPaperSx,
    embedPageContainerSx,
    pageContainerSx,
} from '../theme/pageLayout';

type PageLayoutVariant = 'standard' | 'homeBand' | 'embed';

type PageLayoutProps = {
    children: React.ReactNode;
    variant?: PageLayoutVariant;
};

const PageLayout: React.FC<PageLayoutProps> = ({ children, variant = 'standard' }) => {
    if (variant === 'embed') {
        return (
            <Box sx={embedPageContainerSx}>
                <Paper elevation={3} sx={embedContentPaperSx}>
                    {children}
                </Paper>
            </Box>
        );
    }

    const content = (
        <Box
            sx={{
                ...pageContainerSx,
                textAlign: 'left',
                ...(variant === 'homeBand' ? { mt: 0 } : {}),
            }}
        >
            <Paper
                elevation={3}
                sx={
                    variant === 'homeBand'
                        ? {
                              ...contentPaperSx,
                              boxShadow: {
                                  xs: undefined,
                                  md: '0 8px 32px rgba(15, 23, 42, 0.07)',
                              },
                          }
                        : contentPaperSx
                }
            >
                {children}
            </Paper>
        </Box>
    );

    if (variant === 'homeBand') {
        return (
            <Box
                sx={{
                    width: '100%',
                    bgcolor: { xs: 'transparent', md: PAGE_BAND_COLOR },
                    mt: { xs: -0.5, md: -1 },
                    pb: { xs: 0, md: 1 },
                }}
            >
                {content}
            </Box>
        );
    }

    return content;
};

export default PageLayout;
